<div class="container-root">


    <div class="container">

        <div class="containerTitulo">
            <img [src]="ops.srcImage" class="image" alt="Error al cargar">


            <ion-text>
                <h3 class="ion-text-center title" >
                    {{ops.titleRetry}}
                </h3>
            </ion-text>

            <ion-text *ngIf="ops.infoRetry" class="info ion-text-center">
                {{ops.infoRetry}}
            </ion-text>
        </div>

        <div *ngIf="ops.subtitleRetry" class="contact" lines="none" mode="md">
            <ion-icon class="i-info icon" >

            </ion-icon>
            <ion-text color="primary" class="contact-info" [innerHTML]="ops.subtitleRetry">
            </ion-text>
        </div>

        <div class="botones">
            <button [disabled]="retryAttempt" class="b-btn p-button primary-button" (click)="retryEvent()" >
                <ion-spinner name="crescent" slot="end" *ngIf="retryAttempt" color="light"></ion-spinner>
                <ion-icon class="i-refresh" *ngIf="!retryAttempt">
                </ion-icon>
                {{ops.buttonTextPrimary}}
            </button>

            <button class="b-btn s-button secondary-button"  (click)="goToEvent()">
                {{ops.buttonTextSecondary}}
            </button>
        </div>
    </div>
</div>